export enum ScreenResult {
  WAREHOUSE_LOCATION = 1,
  SORTER_VENTILATION = 2
}
